export default "__VITE_ASSET__63de7dce__"